import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import TailwickContactAvatar from "../ChatLayout/TailwickContactAvatar";
import { i18n } from "../../translate/i18n";



function TicketInfo({ contact, ticket, onClick, tailwickLayout = false }) {
	const title =

		ticket.channel === "email"

			? `${contact.name ? contact.name : "Sem nome"} - (${contact.email})`

			: `${contact.name}  ${contact.company ? `(${contact.company})` :""}` ;

	const subheader =

		ticket.user &&

		`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`;



	if (tailwickLayout) {

		return (

			<button

				type="button"

				onClick={onClick}

				className="flex min-w-0 flex-1 cursor-pointer items-center gap-2.5 border-0 bg-transparent p-0 text-left"

			>

				<TailwickContactAvatar
					size="sm"
					contactId={contact?.id}
					profilePicUrl={contact?.profilePicUrl}
					isGroup={Boolean(contact?.isGroup)}
					channel={ticket?.channel}
					contactChannel={contact?.channel}
				/>

				<div className="min-w-0">

					<h6 className="tailwick-ticket-item__name mb-0.5 truncate text-sm font-semibold">

						{title} #{ticket.id}

					</h6>

					{subheader && (

						<p className="tailwick-ticket-item__preview truncate text-xs">{subheader}</p>

					)}

				</div>

			</button>

		);

	}



	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
			title={`${title} #${ticket.id}`}
			subheader={subheader}
		/>
	);

}



export default TicketInfo;

